import routes from "../utils/routes";

export const agencyRouteConfiguration = {};

export const sourcingPartnerConfiguration = {};

export const routeConfig = {
  ServiceRequestList: {
    component: "ServiceRequestList",
    url: routes.SERVICE_REQUEST,
    menuLabel: "Review List",
  }
}

export const transactionRoutes = [
  routes.PROFILE,
  routes.CUSTOMER_DETAILS,
  routes.CUSTOMER_DETAILS_FEEDBACK_HISTORY,
  routes.CUSTOMER_DETAILS_PAYMENT_HISTORY,
  routes.OPS_CUSTOMER_DETAILS,
  routes.OPS_CUSTOMER_DETAILS_FEEDBACK_HISTORY,
  routes.OPS_CUSTOMER_DETAILS_PAYMENT_HISTORY,
  routes.HOP,
  routes.AGENT_KYC,
];

export default routeConfig;
